import Model from './Model'

export default class InvoiceRuleModel extends Model {
  public id: number|undefined

  resource () : string {
    return 'invoiceRules'
  }
}
